import React from "react";

const CategorySidebar = ({ categories, selectedCategory, onSelectCategory }) => {
    if (!categories || categories.length === 0) {
        return (
            <div className="category-sidebar">
                <p className="category-empty-text">No categories available</p>
            </div>
        );
    }

    return (
        <div className="service-form-section-content">
            <ul className="category-list">
                {/* All Forms */}
                <li
                    className={`category-item ${selectedCategory === null ? "active" : ""}`}
                    onClick={() => onSelectCategory(null)}
                >
                    All Forms
                </li>

                {/* Categories */}
                {categories.map((cat) => (
                    <li
                        key={cat.id}
                        className={`category-item ${selectedCategory === cat.id ? "active" : ""}`}
                        onClick={() => onSelectCategory(cat.id)}
                    >
                        {cat.name}
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default CategorySidebar;
